import { RATIO_HEIGHT } from './constants';

export const floorVideoHeight = (height: number, ratioHeight: number = RATIO_HEIGHT) => {
    return Math.floor(height / ratioHeight) * ratioHeight;
};
